@use "diy_base.module.scss";
@use "foundation/responsive";
@use "foundation/mixins";
@use "foundation/typography";

.diy-block {
  display: flex;
  align-items: center;
  flex-direction: column;

  @include responsive.phone {
    width: 100%;
    padding: 0 20px;
  }

  div.separator {
    width: 0;
    height: 1.777777778em; /* 32px */
    margin: 0 auto;
    border: 3px solid #EEE;

    @include responsive.phone {
      height: 1.5em; /* 24px */
    }
  }
}

.footer {
  margin: 4em 0;
  text-align: center;

  @include responsive.phone {
    padding: 0 20px;
  }

  @include responsive.small-phone {
    :global .action-buttons-container button {
      width: 100%;
    }
  }

  .upgrade-copy {
    display: flex;
    align-items: center;
    font-size: 28px;

    @include responsive.small-phone {
      font-size: 22px;
    }

    > *:first-child {
      margin-right: mixins.em(10px);
    }

    .badge {
      display: flex;
      width: mixins.em(64px);

      svg {
        height: 60px;

        @include responsive.small-phone {
          height: 48px;
        }

        path {
          fill: #fff;
        }
      }
    }
  }

  button.retry {
    margin-top: mixins.em(16px);
  }
}
